// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/battery.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
  color: #32879c;
  border-color: #32879c;
}
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  background-color: #32879c;
  color: #fff;
}

.bg-white {
  background-color: #fff;
}
.headBG {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #358696;
}

.mainDiv {
  margin-top: 80px;
}

.widget {
  background: #ffffff;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}
.widgetIcon img {
  width: 50px;
  height: 50px;
}
.widgetIcon-32 img {
  width: 32px;
  height: 32px;
}
.titlebg {
  font-size: 1.2em;
  color: #000;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
}
.boxDIC {
  background: #ffffff;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  padding: 10px;
  color: #353535;
  /* font-size: 14px; */
}
h5,
.h5 {
  font-size: 1.1rem !important;
}
p {
  line-height: 1rem !important;
}
small,
.small {
  font-size: 80% !important;
}

table tr td {
  font-size: 0.8em;
}
.accordion-button {
  font-size: 0.5em;
}
.accordion-button:not(.collapsed) {
  background-color: #e0e0e0;
  color: #222;
}

.filterForm > .form-label {
  font-size: 0.825em;
}
.form-label {
  font-size: 0.825em;
}

/***************************** PageTwo *******************************/
.bt-graph {
  border-right: solid 1px #b5b5b5;
}

/* media queries start here */
@media screen and (max-width: 740px) {
  .titlebg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 640px) {
  .mainDiv {
    margin-top: 120px;
  }
}

@media screen and (max-width: 480px) {
  .topHeader h2 {
    font-size: 22px;
    padding-right: 3rem;
  }
  .titlebg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 320px) {
  .topHeader h2 {
    font-size: 16px;
    padding-right: 0rem;
  }
}

.btn-primary {
  color: #fff;
  background-color: #358696;
  border-color: #358696;
}

.btn-primary:hover {
  color: #fff;
  background-color: #358696;
  border-color: #358696;
}

.btn-primary:focus {
  color: #fff;
  background-color: #358696;
  border-color: #358696;
}

.btn-primary:active {
  color: #fff;
  background-color: #358696;
  border-color: #358696;
}

.btn-secondary {
  color: #fff;
  background: #7b7878 !important;
  border: silver;
}

.btn-secondary:hover {
  color: #fff;
  background: #7b7878;
  border: silver;
}

.btn-secondary:focus {
  color: #fff;
  background: #7b7878;
  border: silver;
}
.ev-auto {
  margin-top: -18px;
}
.ev-auto button {
  margin-top: 18px;
}

.btr-outer {
  width: 112px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  /* float: left; */
  /* margin-top: 1.5em; */
}
.btr-graph {
  width: 99px;
  height: 160px;
  /* background: url(../images/charging/battery.png) no-repeat center top; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top;
  background-size: 80%; /* Adjust the size of the background image in pixels */
  margin-left: auto;
  margin-right: auto;
  padding-top: 19%;
  padding-left: 13px;
  padding-right: 13px;
  padding-bottom: 12px;
  position: relative;
}
.btr-range {
  border-radius: 3px;
  width: 60%;
  height: 10%;
  position: absolute;
  bottom: 18px;
  margin-left: 7px;
  border-radius: 4px;
  background: rgb(233, 129, 121);
  background: linear-gradient(
    0deg,
    rgba(233, 129, 121, 1) 0%,
    rgba(247, 205, 202, 1) 100%
  );
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/DigitalInstrumentCluster/Filterpage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;;EASE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,0EAA0E;EAC1E,wEAAgE;EAChE,oBAAoB,EAAE,sDAAsD;EAC5E,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B;;;;GAIC;AACH","sourcesContent":[".btn-outline-primary {\n  color: #32879c;\n  border-color: #32879c;\n}\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:visited,\n.btn-outline-primary:active,\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  background-color: #32879c;\n  color: #fff;\n}\n\n.bg-white {\n  background-color: #fff;\n}\n.headBG {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #358696;\n}\n\n.mainDiv {\n  margin-top: 80px;\n}\n\n.widget {\n  background: #ffffff;\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n}\n.widgetIcon img {\n  width: 50px;\n  height: 50px;\n}\n.widgetIcon-32 img {\n  width: 32px;\n  height: 32px;\n}\n.titlebg {\n  font-size: 1.2em;\n  color: #000;\n  font-weight: 500;\n  margin-bottom: 10px;\n  text-align: center;\n}\n.boxDIC {\n  background: #ffffff;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  padding: 10px;\n  color: #353535;\n  /* font-size: 14px; */\n}\nh5,\n.h5 {\n  font-size: 1.1rem !important;\n}\np {\n  line-height: 1rem !important;\n}\nsmall,\n.small {\n  font-size: 80% !important;\n}\n\ntable tr td {\n  font-size: 0.8em;\n}\n.accordion-button {\n  font-size: 0.5em;\n}\n.accordion-button:not(.collapsed) {\n  background-color: #e0e0e0;\n  color: #222;\n}\n\n.filterForm > .form-label {\n  font-size: 0.825em;\n}\n.form-label {\n  font-size: 0.825em;\n}\n\n/***************************** PageTwo *******************************/\n.bt-graph {\n  border-right: solid 1px #b5b5b5;\n}\n\n/* media queries start here */\n@media screen and (max-width: 740px) {\n  .titlebg {\n    font-size: 0.9em;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .mainDiv {\n    margin-top: 120px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .topHeader h2 {\n    font-size: 22px;\n    padding-right: 3rem;\n  }\n  .titlebg {\n    font-size: 0.9em;\n  }\n}\n\n@media screen and (max-width: 320px) {\n  .topHeader h2 {\n    font-size: 16px;\n    padding-right: 0rem;\n  }\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #358696;\n  border-color: #358696;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #358696;\n  border-color: #358696;\n}\n\n.btn-primary:focus {\n  color: #fff;\n  background-color: #358696;\n  border-color: #358696;\n}\n\n.btn-primary:active {\n  color: #fff;\n  background-color: #358696;\n  border-color: #358696;\n}\n\n.btn-secondary {\n  color: #fff;\n  background: #7b7878 !important;\n  border: silver;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background: #7b7878;\n  border: silver;\n}\n\n.btn-secondary:focus {\n  color: #fff;\n  background: #7b7878;\n  border: silver;\n}\n.ev-auto {\n  margin-top: -18px;\n}\n.ev-auto button {\n  margin-top: 18px;\n}\n\n.btr-outer {\n  width: 112px;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 600;\n  /* float: left; */\n  /* margin-top: 1.5em; */\n}\n.btr-graph {\n  width: 99px;\n  height: 160px;\n  /* background: url(../images/charging/battery.png) no-repeat center top; */\n  background: url(/public/assets/battery.png) no-repeat center top;\n  background-size: 80%; /* Adjust the size of the background image in pixels */\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 19%;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-bottom: 12px;\n  position: relative;\n}\n.btr-range {\n  border-radius: 3px;\n  width: 60%;\n  height: 10%;\n  position: absolute;\n  bottom: 18px;\n  margin-left: 7px;\n  border-radius: 4px;\n  background: rgb(233, 129, 121);\n  background: linear-gradient(\n    0deg,\n    rgba(233, 129, 121, 1) 0%,\n    rgba(247, 205, 202, 1) 100%\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
